/** @jsx jsx */

import { jsx } from '@emotion/react';
import { Grid } from '@atlaskit/primitives';
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */
const WeekDayGrid = ({
  testId,
  children,
  isHidden
}) => {
  const row = jsx(Grid, {
    testId: testId,
    templateColumns: "repeat(7, minmax(max-content, 1fr))",
    role: "row"
  }, children);
  return isHidden ? jsx("div", {
    "aria-hidden": "true"
  }, row) : row;
};
export default WeekDayGrid;